import Api from '@/services/Api'

const URL = 'cat/recetas/';

export default {
    
    fetch(params) {
        return Api().get(URL, {
            params: params
        })
    },
    getById(id) {
        return Api().get(URL + id)
    },
    save(params) {
        let url = URL;
        if ('pk' in params) {
            params.codigo = params.pk;
            return Api().put(url + params.pk + '/', params)
        }
        return Api().post(url, params)
    },
    postAction(id, action, params) {
        return Api().post(`${URL}${id}/${action}/`, params);
    },
    agregarListaPrecioE(id,params){
        return Api().post(`${URL}${id}/agregar_lista_precio_e/`, params);
    },
    solicitarAutorizacion(id,params){
        return Api().post(`${URL}${id}/solicitar_autorizacion/`, params);
    },
    reabrir(id,params){
        return Api().post(`${URL}${id}/reabrir/`, params);
    },
    modificarFechaReceta(id,params){
        return Api().post(`${URL}${id}/modificar_fecha_receta/`, params);
    },
    modificarFechaListaPrecio(id,params){
        return Api().post(`${URL}${id}/modificar_fecha_receta/`, params);
    }
}